/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { BakendHttpResponse } from '../bakend-http-response';

import { getJwksAuthGrafanaJwksGet } from '../fn/grafana/get-jwks-auth-grafana-jwks-get';
import { GetJwksAuthGrafanaJwksGet$Params } from '../fn/grafana/get-jwks-auth-grafana-jwks-get';
import { getPanelLinkGrafanaPanelsPanelKeyGet } from '../fn/grafana/get-panel-link-grafana-panels-panel-key-get';
import { GetPanelLinkGrafanaPanelsPanelKeyGet$Params } from '../fn/grafana/get-panel-link-grafana-panels-panel-key-get';
import { BackendGrafanaPanelLinkResponseDto } from '../models/backend-grafana-panel-link-response-dto';
import { BackendJwksResponseDto } from '../models/backend-jwks-response-dto';

@Injectable({ providedIn: 'root' })
export class BackendApiGrafanaService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getPanelLinkGrafanaPanelsPanelKeyGet()` */
  static readonly GetPanelLinkGrafanaPanelsPanelKeyGetPath = '/grafana/panels/{panel_key}';

  /**
   * Подписанный URL для встраивания панели Grafana.
   *
   * Возвращает URL вида `https://grafana.host/d-solo/<uid>?...&auth_token=<jwt>`. JWT подписан RS256-ключом сервиса; Grafana проверяет подпись через JWKS. Для проектных панелей дополнительно валидирует доступ к `project_id`.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getPanelLinkGrafanaPanelsPanelKeyGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPanelLinkGrafanaPanelsPanelKeyGet$Response(
    params: GetPanelLinkGrafanaPanelsPanelKeyGet$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendGrafanaPanelLinkResponseDto>> {
    return getPanelLinkGrafanaPanelsPanelKeyGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Подписанный URL для встраивания панели Grafana.
   *
   * Возвращает URL вида `https://grafana.host/d-solo/<uid>?...&auth_token=<jwt>`. JWT подписан RS256-ключом сервиса; Grafana проверяет подпись через JWKS. Для проектных панелей дополнительно валидирует доступ к `project_id`.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getPanelLinkGrafanaPanelsPanelKeyGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPanelLinkGrafanaPanelsPanelKeyGet(
    params: GetPanelLinkGrafanaPanelsPanelKeyGet$Params,
    context?: HttpContext,
  ): Observable<BackendGrafanaPanelLinkResponseDto> {
    return this.getPanelLinkGrafanaPanelsPanelKeyGet$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendGrafanaPanelLinkResponseDto>): BackendGrafanaPanelLinkResponseDto => r.body),
    );
  }

  /** Path part for operation `getJwksAuthGrafanaJwksGet()` */
  static readonly GetJwksAuthGrafanaJwksGetPath = '/auth/grafana/jwks';

  /**
   * JWKS публичных ключей для верификации Grafana JWT.
   *
   * Публичный эндпоинт. Grafana ходит по этому URL (см. `[auth.jwt].jwk_set_url` в grafana.ini) и кеширует ключи.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getJwksAuthGrafanaJwksGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  getJwksAuthGrafanaJwksGet$Response(
    params?: GetJwksAuthGrafanaJwksGet$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendJwksResponseDto>> {
    return getJwksAuthGrafanaJwksGet(this.http, this.rootUrl, params, context);
  }

  /**
   * JWKS публичных ключей для верификации Grafana JWT.
   *
   * Публичный эндпоинт. Grafana ходит по этому URL (см. `[auth.jwt].jwk_set_url` в grafana.ini) и кеширует ключи.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getJwksAuthGrafanaJwksGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getJwksAuthGrafanaJwksGet(
    params?: GetJwksAuthGrafanaJwksGet$Params,
    context?: HttpContext,
  ): Observable<BackendJwksResponseDto> {
    return this.getJwksAuthGrafanaJwksGet$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendJwksResponseDto>): BackendJwksResponseDto => r.body),
    );
  }
}
